import type React from 'react';
import { Tabs } from 'antd';
import { useNavigate } from 'react-router';
import type { TabsProps } from 'antd';
import 'styles/ant-design.css';
import { constructClaimDetailPath } from 'constants/path';
import { useTranslation } from 'react-i18next';
import { getClaimConfigTabs } from './claim-config-tabs';
import { useCallback, useMemo } from 'react';
import { ClaimResponseDtoStatusEnum } from 'libs/pinnacle-sdk';

interface NavigationTabsProps {
  claimId?: string;
  claimStatus?: ClaimResponseDtoStatusEnum;
  tabId?: string;
}

const NavigationTabs: React.FC<NavigationTabsProps> = ({
  claimId,
  claimStatus,
  tabId,
}) => {
  const { t } = useTranslation();
  const configTabs = getClaimConfigTabs(claimStatus, t);
  const navigate = useNavigate();

  const onChange = useCallback(
    (key: string) => {
      navigate(constructClaimDetailPath(claimId || '', key));
    },
    [navigate, claimId]
  );

  const items: TabsProps['items'] = useMemo(
    () =>
      configTabs
        .filter((item) => !item.hide)
        .map((tab) => ({
          key: tab.id.toString(),
          label: tab.tab,
          disabled: tab.disabled,
        })),
    [configTabs]
  );

  return (
    <div className="bg-[#E3F2FB] p-1 rounded-lg">
      <Tabs
        activeKey={tabId || '0'}
        onChange={onChange}
        items={items}
        className="custom-tabs custom-claim-tabs"
        tabBarGutter={8}
        tabBarStyle={{ margin: 0 }}
        animated={false}
      />
    </div>
  );
};

export default NavigationTabs;
